import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthenticationService } from '@promojds-front/authentication-data-access';

export function queryInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthenticationService);
  return from(authService.getToken()).pipe(switchMap(token => {
    if (token !== null) {
      const reqWithBearer = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
      return next(reqWithBearer);
    }
    return next(req)
  }));
}
